import React, { useEffect, useState } from 'react';
import { Button, Col, Row } from "react-bootstrap";
import { Trash2 } from "react-feather";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { getToken } from "../../Utils/Common";
//import StundenMaterialModal from "./StundenMaterialModal";
import NewIndividualMaterialModal from "./NewIndividualMaterialModal";

const onTextAreaChange = (text) => {
    const lines = parseText(text);
    const evaluatedLines = lines.map((line) => evalText(line));
    const total = evaluatedLines.reduce((sum, value) => sum + value, 0);
    return total.toString().replace(/\./g, ',');
};

const parseText = (e) => {
    const text = e
    const lines = text.split('\n');
    return lines.filter((line) => line.trim() !== ''); // Filter out empty lines
};

const evalText = (text) => {
    try {
        const problem = text.split('=')[1];
        if (!problem) return 0;
        return eval(problem.toString().replace(/,/g, '.'))
    } catch (e) {
        return 0;
    }
};

function StundenMaterial(props) {

    const [materialData, setMaterialData] = useState(props.materialData);
    const [newMaterialData, setNewMaterialData] = useState([]);
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    useEffect(() => {
        setMaterialData(props.materialData);
    }, [props.materialData]);

    useEffect(async () => {

        async function fetchAllMaterial() {

            let apiBody = JSON.stringify({
                "lv_id": sessionStorage.getItem("projectID"), "token": getToken()
            })

            return await fetch(process.env.REACT_APP_BACKEND_API_URI + "parser/read_lvattributes", {
                method: "POST", headers: {
                    "Content-Type": "application/json"
                }, body: apiBody
            })
        }

        let materialNEW = []

        fetchAllMaterial().then(response => response.json()).then(data => {
            data.data.forEach((item) => {
                materialNEW.push({
                    "id": item.ref, "position": item.ref, "description": item.hinweis, "unit": item.unit, "source": "LV",
                    aufmas:"item.aufmas"
                })
            })
        })

        console.log(newMaterialData)
        setNewMaterialData(materialNEW)

    }, []);

    function deleteMaterial(id) {

        props.setIsChange(false)
        let newMaterialData = materialData.filter(item => item.id !== id);
        setMaterialData(newMaterialData);
        while (props.materialData.length > 0) {
            props.materialData.pop()
        }
        newMaterialData.map((item) => {
            props.materialData.push(item);
        })
    }

    // function handleMengeChange(id, menge) {
    //     props.setIsChange(false);
    //     let materialDatas = materialData.map(item => {
    //         if (item.id === id) {
    //             item.menge = menge;
    //             return {
    //                 ...item,
    //                 menge // Update menge value
    //             };
    //         }
    //         return item;
    //     });

    //     setMaterialData(materialDatas);
    // }

    // function handleMengeChange(id, event) {
    //     props.setIsChange(false);

    //     const updatedMaterialData = [...materialData];
    //     const index = updatedMaterialData.findIndex((item) => item.id === id);

    //     if (index !== -1) {
    //         updatedMaterialData[index].menge = event;
    //         setMaterialData(updatedMaterialData);
    //     } else {
    //         console.warn(`Material with id ${id} not found`);
    //     }
    // }


    function getMaterialTableBody(materialData,type) {
        return materialData?.map((item, i) => (
            <TableRow
                type={type}
                disableStatus={props.disableStatus}
                key={i.toString()}
                setIsChange={props.setIsChange}
                materialData={props.materialData}
                setMaterialData={setMaterialData}
                deleteMaterial={deleteMaterial}
                originState={props.originState}
                item={item}
                setStundenReportData={props.setStundenReportData}
                stundenReportData={props.stundenReportData}
            />
        ));
    }



    return (<>
        <Row>
            <Col>
                <label className="handwai-text-label-main add-bottom-0-margin">{"Material"}</label>
            </Col>
            {!props.originState || props.disableStatus && <Col className="add-flex-end">
                <Button onClick={handleShow}
                    className='handwai-btn-create'>
                    <FontAwesomeIcon icon={faPlus} /></Button>
            </Col>}
        </Row>
        <br />
        <table id="materialTable" className="table handwai-white-text">
            <thead>
                <tr>
                    <th>Position</th>
                    <th>Kurztext</th>
                    <th>Einheit</th>
                    <th>Menge</th>
                    <th>Teilaufmaß</th>
                    {!props.originState||props.disableStatus && <th>Löschen</th>}
                </tr>
            </thead>
            <tbody>{getMaterialTableBody(props.materialData,props.type)}</tbody>
        </table>
        {/*<StundenMaterialModal show={show} handleClose={handleClose} newMaterialData={newMaterialData}
            materialDataInfo={props.materialData} setMaterialData={setMaterialData}
            setIsChange={props.setIsChange} />*/}
        <NewIndividualMaterialModal show={show} handleClose={handleClose}
        materialData={props.materialData} setMaterialData={setMaterialData}
        setIsChange={props.setIsChange}
                                    setStundenReportData={props.setStundenReportData}
                stundenReportData={props.stundenReportData}
        />
    </>);
}

export default StundenMaterial;

















/*
import React, {useEffect, useState} from 'react';
import {Button, Col, Row} from "react-bootstrap";
import {Trash2} from "react-feather";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPlus} from "@fortawesome/free-solid-svg-icons";
import MaterialModal from "./MaterialModal";
import {getToken} from "../../Utils/Common";

function Material(props) {

    const [materialData, setMaterialData] = useState(props.materialData);
    const [newMaterialData, setNewMaterialData] = useState([]);
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    useEffect(() => {
        setMaterialData(props.materialData);
    }, [props.materialData]);

    useEffect(async () => {

        async function fetchAllMaterial() {

            let apiBody = JSON.stringify({
                "lv_id": sessionStorage.getItem("projectID"), "token": getToken()
            })

            return await fetch(process.env.REACT_APP_BACKEND_API_URI + "parser/read_lvattributes", {
                method: "POST", headers: {
                    "Content-Type": "application/json"
                }, body: apiBody
            })
        }

        let materialNEW = []

        fetchAllMaterial().then(response => response.json()).then(data => {
            data.data.forEach((item) => {
                materialNEW.push({
                    "id": item.ref, "position": item.ref, "description": item.hinweis, "unit": item.unit, "source": "LV"
                })
            })
        })

        setNewMaterialData(materialNEW)

    }, []);

    function deleteMaterial(id) {

        props.setIsChange(false)
        let newMaterialData = materialData.filter(item => item.id !== id);
        setMaterialData(newMaterialData);
        while (props.materialData.length > 0) {
            props.materialData.pop()
        }
        newMaterialData.map((item) => {
            props.materialData.push(item);
        })

    }

    function handleMengeChange(id, menge) {
        props.setIsChange(false)

        let materialData = props.materialData;
        materialData.map((item) => {
            if (item.id === id) {
                item.menge = menge;
            }
        });
        setMaterialData(materialData);

    }

    function getMaterialTableBody(materialData) {

        return materialData?.map((item) => (<tr key={item.id}
                                                style={{backgroundColor: item.position === "-" ? '#c6a500' : 'inherit'}}
        >
            <td>{item.position}</td>
            <td>{item.description}</td>
            <td>
                {item.unit}
            </td>
            <td><input
                disabled={props.originState}
                type="text" className="table-menge-input" defaultValue={item.menge}
                onChange={(event) => handleMengeChange(item.id, event.target.value)}/>
            </td>
            {!props.originState && <td
                style={{
                    textAlign: "center",
                }}
            >
                <button className="btn btn-danger" onClick={() => deleteMaterial(item.id)}>
                    <Trash2/>
                </button>
            </td>}
        </tr>));
    }


    return (<>
        <Row>
            <Col>
                <label className="handwai-text-label-main add-bottom-0-margin">{"Material"}</label>
            </Col>
            {!props.originState && <Col className="add-flex-end">
                <Button onClick={handleShow}
                        className='handwai-btn-create'>
                    <FontAwesomeIcon icon={faPlus}/></Button>
            </Col>}
        </Row>
        <br/>
        <table id="materialTable" className="table handwai-white-text">
            <thead>
            <tr>
                <th>Position</th>
                <th>Kurztext</th>
                <th>Einheit</th>
                <th>Menge</th>
                {!props.originState && <th>Löschen</th>}
            </tr>
            </thead>
            <tbody>{getMaterialTableBody(props.materialData)}</tbody>
        </table>
        <MaterialModal  show={show} handleClose={handleClose} newMaterialData={newMaterialData}
                       materialDataInfo={props.materialData} setMaterialData={setMaterialData}
                       setIsChange={props.setIsChange}/>
    </>);
}

export default Material;
*/


const TableRow = ({ item,disableStatus,
    originState,
    deleteMaterial,
    materialData, setMaterialData, setIsChange, stundenReportData, setStundenReportData,type }) => {
    const [menge, setMenge] = useState(item.menge);

    console.log(menge);
    // const [aufmas, setAufmas] = useState(item.aufmas);

useEffect(()=>{
    setMenge(item.menge)
},[materialData.menge])

    // console.log(setAufmas);
    return (
        <tr key={item.id} style={{ backgroundColor: item.position === "-" ? '#c6a500' : 'inherit' }}>
            <td>{item.position}</td>
            <td>{item.description}</td>
            <td>{item.unit}</td>
            <td>
                <input
                    style={{
                        fontSize: 12,
                        minWidth: 70,
                    }}
                    disabled={originState || disableStatus}
                    type="text"
                    className="table-menge-input"
                    value={item.menge}
                    onChange={(e) => {
                        setIsChange(true)
                        setMenge(e.target.value)
                        const updatedMaterialData = [...materialData];
                        const updatedStundenReportData = { ...stundenReportData }
                        const index = updatedMaterialData.findIndex((i) => item.id === i.id);

                        if (index !== -1) {
                            
                            updatedMaterialData[index].menge = e.target.value;
                            updatedMaterialData[index].aufmas = '';
                            console.log(updatedMaterialData);
                            if (type==="Stunden-Anmeldung"){
                                updatedStundenReportData.material_angemeldet = updatedMaterialData
                            }
                            else if(type==="Stunden-Abmeldung"){
                                updatedStundenReportData.material_abgemeldet = updatedMaterialData
                            }
                            setMaterialData(updatedMaterialData);
                            setStundenReportData(updatedStundenReportData)
                        } else {
                            console.warn(`Material with id ${item.id} not found`);
                        }
                    }
                    }
                    onBlur={(e) => {
                        setIsChange(false)
                        const event = e.target.value
                        const updatedMaterialData = [...materialData];
                        const index = updatedMaterialData.findIndex((i) => item.id === i.id);

                        if (index !== -1) {
                            updatedMaterialData[index].menge = event;
                            setMaterialData(updatedMaterialData);
                        } else {
                            console.warn(`Material with id ${item.id} not found`);
                        }
                    }}
                />
            </td>
            <td>
                <textarea
                    style={{ backgroundColor: '#1b1b1b', color: '#fff' }}
                    disabled={originState||disableStatus}
                    value={item.aufmas}
                    onChange={(e) => {
                        setIsChange(false)
                        const menge = onTextAreaChange(e.target.value)
                        setMenge(menge)
                        const updatedMaterialData = [...materialData];
                        const updatedStundenReportData = { ...stundenReportData }
                        const index = updatedMaterialData.findIndex((i) => item.id === i.id);

                        if (index !== -1) {
                            updatedMaterialData[index].aufmas = e.target.value;
                            updatedMaterialData[index].menge = menge;
                            console.log(updatedMaterialData);
                            if (type==="Stunden-Anmeldung"){
                                updatedStundenReportData.material_angemeldet = updatedMaterialData
                            }
                            else if(type==="Stunden-Abmeldung"){
                                updatedStundenReportData.material_abgemeldet = updatedMaterialData
                            }
                            setMaterialData(updatedMaterialData);
                            setStundenReportData(updatedStundenReportData)
                        } else {
                            console.warn(`Material with id ${item.id} not found`);
                        }
                    }}
                    // onBlur={(e) => {
                    //     setIsChange(false);
                    //     const event = e.target.value
                    //     const menge = onTextAreaChange(event)
                    //     setMenge(menge)
                    //     const updatedMaterialData = [...materialData];
                    //     const updatedTaetigkeitsberichtData = { ...taetigkeitsberichtData }
                    //     const index = updatedMaterialData.findIndex((i) => item.id === i.id);

                    //     if (index !== -1) {
                    //         updatedMaterialData[index].aufmas = event;
                    //         updatedMaterialData[index].menge = onTextAreaChange(aufmas);
                    //         updatedTaetigkeitsberichtData.material = updatedMaterialData
                    //         setMaterialData(updatedMaterialData);
                    //         setTaetigkeitsberichtData(updatedTaetigkeitsberichtData)
                    //     } else {
                    //         console.warn(`Material with id ${item.id} not found`);
                    //     }
                    // }}
                />
            </td>
            {!originState || disableStatus && (
                <td style={{ textAlign: 'center' }}>
                    <button className="btn btn-danger" onClick={() => deleteMaterial(item.id)}>
                        <Trash2 />
                    </button>
                </td>
            )}
        </tr>
    )
}